import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HomeIcon from '@mui/icons-material/Home';
import React from 'react';

export interface MobileNavItem {
  label: string;
  path: string;
  icon: React.ReactNode;
}

export const MOBILE_NAV_ITEMS: MobileNavItem[] = [
  { label: 'Inicio', path: '/home', icon: <HomeIcon /> },
  { label: 'Finanzas', path: '/finance', icon: <AccountBalanceIcon /> },
];
